<h1 mat-dialog-title>
  <p>{{ 'dashboard.operational.dialogs.selectGrid' | t }}</p>
  <sn-searchbar (valueChange)="onSearchValueChange($event)"></sn-searchbar>
</h1>
<mat-dialog-content>
  <sn-data-list #list reloadByQueryParams [fetchFn]="loadData" [feedFn]="feedData">
    <sn-infinite-scroll>
      <sn-pull-to-refresh>
        <ng-template [ngIf]="list.dataSource.data.length" [ngIfThen]="listTmpl"></ng-template>
        <ng-template
          [ngIf]="!list.dataSource.data.length && list.dataIsInited"
          [ngIfThen]="emptyTmpl"
        ></ng-template>
      </sn-pull-to-refresh>
    </sn-infinite-scroll>
  </sn-data-list>
</mat-dialog-content>
<mat-dialog-actions snButtonGroup>
  <button mat-button color="danger" (click)="cancel()">{{ 'common.cancel' | t }}</button>
</mat-dialog-actions>

<ng-template #listTmpl>
  <mat-table [dataSource]="list.dataSource.data">
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>{{ 'common.name' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ item.name }}
        <sn-icon size="sm" *ngIf="item.isPrivate">lock</sn-icon>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="geometry">
      <mat-header-cell *matHeaderCellDef>{{ 'common.geometry' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ item.geometry.cols }} × {{ item.geometry.rows }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="cameras">
      <mat-header-cell *matHeaderCellDef>{{ 'common.cameras' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let item">
        <sn-camera-stats [stats]="item.stats"></sn-camera-stats>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="owner">
      <mat-header-cell *matHeaderCellDef>{{ 'common.owner' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let item">
        <sn-object-owner [object]="item"></sn-object-owner>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
    <mat-row (click)="onSelected(item)" *matRowDef="let item; columns: columns"> </mat-row>
  </mat-table>
</ng-template>

<ng-template #emptyTmpl>
  <sn-empty-state icon="cancel_presentation" [title]="'common.noResults' | t">
    {{ 'common.noResultsMatchSearch' | t }}
  </sn-empty-state>
</ng-template>
